import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import { createDateObject, formatIsoDate, addDays } from '../../../Helpers/dateFormatter';
import DailyDietPlanQuery from '../../DailyDietPlan/Fetch/DailyDietPlanQuery';
import InsertFavoriteFromFavoritesMutation from './InsertFavoriteToDayplanMutation';
import clearShoppingListCache from '../../ShoppingList/clearShoppingListCache';

const InsertFavoriteToDayplanConnectorApollo = ({ children }) => {
  const client = useApolloClient();

  const [insertFavoriteToDayplan] = useMutation(InsertFavoriteFromFavoritesMutation);

  const createInsertFavoriteToDayplan = async (date, replacementId, skipValidation) => {
    const variables = {
      date,
      replacementId,
      skipValidation,
    };

    const response = await insertFavoriteToDayplan({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: DailyDietPlanQuery,
          variables: {
            date,
            canBeCopiedToDate: formatIsoDate(addDays(createDateObject(date), 1)),
          },
        },
      ],
    });

    clearShoppingListCache(client);

    return response;
  };

  return children({
    insertFavoriteToDayplan: createInsertFavoriteToDayplan,
  });
};

InsertFavoriteToDayplanConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default InsertFavoriteToDayplanConnectorApollo;
